import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const APP_TIMEZONE = 'Asia/Kolkata';

// Wrapper around dayjs()
const appDayjs = (...args) => {
    return dayjs(...args).tz(APP_TIMEZONE);
};

appDayjs.utc = dayjs.utc;
appDayjs.tz = dayjs.tz;
appDayjs.extend = dayjs.extend;

export default appDayjs;